export const getNftPrice = () => {
  return parseFloat(process.env.REACT_APP_NFT_PRICE);
}
